// Author YuJiaBei
// Date 2021-01-19 10:38:52

class SithMesMstCalendar {
constructor({
        id = null,
        calendarType = '',
        beginTime = '',
        endTime = '',
        mstLocationId = '',
        mstLocationName = '',
        ratedWorkingHours = '',
        headCount = '',
        remark = ''}
= {}) {
    this.id = id;
    this.calendarType = calendarType;
    this.beginTime = beginTime;
    this.endTime = endTime;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.ratedWorkingHours = ratedWorkingHours;
    this.headCount = headCount;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstCalendar();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'calendarType',
        label: 'label.sith.mst.sithMesMstCalendar.grid.calendarType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '法定节假日' },
                            { value: '2', text: '法定串休工作日' },
                            { value: '3', text: '加班' },
                            { value: '4', text: '调休' },
                            { value: '5', text: '设备检修' },
                            { value: '6', text: 'SAP关闭' }
            ]
        }
        },
        {
        key: 'beginTime',
        label: 'label.sith.mst.sithMesMstCalendar.grid.beginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'endTime',
        label: 'label.sith.mst.sithMesMstCalendar.grid.endTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstCalendar.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationNodeCode',
        label: 'label.sith.mst.sithMesMstCalendar.grid.mstLocationNodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ratedWorkingHours',
        label: 'label.sith.mst.sithMesMstCalendar.grid.ratedWorkingHours',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'headCount',
        label: 'label.sith.mst.sithMesMstCalendar.grid.headCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstCalendar.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    calendarTypeFilter : "",
    beginTimeRteFilter : "",
    beginTimeLteFilter : "",
    endTimeRteFilter : "",
    endTimeLteFilter : "",
    mstLocationIdFilter : "",
    startsWithMstLocationNodeCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'calendarTypeFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.calendarType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '法定节假日' },
                { value: '2', text: '法定串休工作日' },
                { value: '3', text: '加班' },
                { value: '4', text: '调休' },
                { value: '5', text: '设备检修' },
                { value: '6', text: 'SAP关闭' }
            ]
        }
        },
        {
        key: 'beginTimeRteFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.beginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginTimeLteFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.beginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.endTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.endTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'mstLocationIdFilter',
        label: 'label.sith.mst.sithMesMstCalendar.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'calendarType',
        label: 'label.sith.mst.sithMesMstCalendar.entity.calendarType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '法定节假日' },
                { value: '2', text: '法定串休工作日' },
                { value: '3', text: '加班' },
                { value: '4', text: '调休' },
                { value: '5', text: '设备检修' },
                { value: '6', text: 'SAP关闭' }
            ]
        }
        },
        {
        key: 'beginTime',
        label: 'label.sith.mst.sithMesMstCalendar.entity.beginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'endTime',
        label: 'label.sith.mst.sithMesMstCalendar.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstCalendar.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'ratedWorkingHours',
        label: 'label.sith.mst.sithMesMstCalendar.entity.ratedWorkingHours',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'headCount',
        label: 'label.sith.mst.sithMesMstCalendar.entity.headCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstCalendar.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstCalendar, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
